import { IconLongArrowRightRegular32 } from '@croquiscom/zds';
import styled from '@emotion/styled';

import { Gray_Light_150, Gray_Light_600, Typography } from '@common/styles';

export function ViewMore({ onClick }: { onClick?: () => void }) {
  return (
    <ViewMoreContainer className={Typography.BODY_13_SEMIBOLD} onClick={onClick}>
      <ViewMoreIcon>
        <IconLongArrowRightRegular32 size={24} color={Gray_Light_600} />
      </ViewMoreIcon>
      더 보기
    </ViewMoreContainer>
  );
}

const ViewMoreContainer = styled.button`
  margin: 0 16px 0 0;
  color: ${Gray_Light_600};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ViewMoreIcon = styled.div`
  padding: 12px;
  margin-bottom: 4px;
  border: 1px solid ${Gray_Light_150};
  border-radius: 50%;
  height: 48px;
  width: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
